import script from "./manual-ot-record.vue?vue&type=script&setup=true&lang=js"
export * from "./manual-ot-record.vue?vue&type=script&setup=true&lang=js"

import "./manual-ot-record.vue?vue&type=style&index=0&id=32b38031&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b38031"]])

export default __exports__